const BorderCard = ({
  children,
  variant = "top",
  bg = false,
  className = "",
  padding = "",
}) => {
  const baseClasses = `border border-gray-200 dark:border-gray-800/80 ${
    padding ? padding : "px-4 py-3.5"
  }`;
  const variantClasses = {
    top: "rounded-t-2xl flex items-center justify-between bg-white dark:bg-gray-900",
    bottom: "rounded-b-2xl flex border-t-0 bg-white dark:bg-gray-900/60",
  };
  const cardClasses = `${baseClasses} ${variantClasses[variant]} ${className}`;

  // Background styles if bg is true
  const bgClasses = bg ? "bg-[#F5F5F580] dark:bg-gray-900/60 workflow-dotted-bg" : "";

  return (
    <div className={`${cardClasses} ${bgClasses}`}>
      {children}
    </div>
  );
};

export default BorderCard;
